import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Store } from '~/features/store/types/store.type';

/**
 * 매장 상세 조회
 * @description ADMIN, STORE_MANAGER 권한 필요
 * @endpoint GET /admin/stores/{id}
 * @param id - 매장 ID
 * @returns 매장 상세 정보
 */
export function getStoreApi(id: number) {
  return axiosInstance.get<ApiResponse<Store>>(`/admin/stores/${id}`);
}
